import * as types from './EditRadProfileActionType';

//--------------------Edit Provider Profile Start -----------------//
 
// Fetch Edit Provider Profile
export const fetchEditRadProfileRequest = (radiologistID = 0) => ({
    type: types.FETCH_EDITRAD_PROFILE_REQUEST,
    payload: { radiologistID }
});
export const fetchEditRadProfileSuccess = (data) => ({
    type: types.FETCH_EDITRAD_PROFILE_SUCCESS,
    payload: data
});
export const fetchEditRadProfileFailure = (error) => ({
    type: types.FETCH_EDITRAD_PROFILE_FAILURE,
    payload: error
});

// Fetch Edit Provider Profile Contract Summary
export const fetchEditRadProfileContractSummaryRequest = (radiologistID = 0) => ({
    type: types.FETCH_EDITRAD_PROFILE_CONTRACT_SUMMARY_REQUEST,
    payload: { radiologistID }
});
export const fetchEditRadProfileContractSummarySuccess = (data) => ({
    type: types.FETCH_EDITRAD_PROFILE_CONTRACT_SUMMARY_SUCCESS,
    payload: data
});
export const fetchEditRadProfileContractSummaryFailure = (error) => ({
    type: types.FETCH_EDITRAD_PROFILE_CONTRACT_SUMMARY_FAILURE,
    payload: error
});

// Fetch Edit Provider Profile Contract Documents
export const fetchEditRadProfileContractDocumentsRequest = (contractSummaryID = 0) => ({
    type: types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_REQUEST,
    payload: { contractSummaryID }
});
export const fetchEditRadProfileContractDocumentsSuccess = (data) => ({
    type: types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_SUCCESS,
    payload: data
});
export const fetchEditRadProfileContractDocumentsFailure = (error) => ({
    type: types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_FAILURE,
    payload: error
});


// Save Provider Profile
export const saveRadRequest = (payload, showSuccessMessage = true) => ({
    type: types.SAVE_RAD_REQUEST,
    payload,
    showSuccessMessage
});
export const saveRadSuccess = (data, radiologistData) => ({
    type: types.SAVE_RAD_SUCCESS,
    payload: data,
    radiologistData
});
export const saveRadFailure = (error) => ({
    type: types.SAVE_RAD_FAILURE,
    payload: error
});
 
// Get City and State by Zip Code
export const getCityStateByZipCodeRequest = (zipCode, addressType) => ({
    type: types.GET_CITY_STATE_BY_ZIPCODE_REQUEST,
    payload: { zipCode, addressType }
});
export const getCityStateByZipCodeSuccess = (data, addressType) => ({
    type: types.GET_CITY_STATE_BY_ZIPCODE_SUCCESS,
    payload: { data, addressType }
});
export const getCityStateByZipCodeFailure = (error, addressType) => ({
    type: types.GET_CITY_STATE_BY_ZIPCODE_FAILURE,
    payload: { error, addressType }
});
 
// Save Provider Note
export const saveRadNoteRequest = (payload) => ({
    type: types.SAVE_RAD_NOTE_REQUEST,
    payload
});
export const saveRadNoteSuccess = (data) => ({
    type: types.SAVE_RAD_NOTE_SUCCESS,
    payload: data
});
export const saveRadNoteFailure = (error) => ({
    type: types.SAVE_RAD_NOTE_FAILURE,
    payload: error
});

// Save Radiologist Tags
export const saveRadTagsRequest = (payload, onSuccess = null) => ({
    type: types.SAVE_RAD_TAGS_REQUEST,
    payload,
    onSuccess,
});
export const saveRadTagsSuccess = (data) => ({
    type: types.SAVE_RAD_TAGS_SUCCESS,
    payload: data,
});
export const saveRadTagsFailure = (error) => ({
    type: types.SAVE_RAD_TAGS_FAILURE,
    payload: error,
});
 
 
// Fetch Week Rotation Template by ID
export const fetchWeekRotationTemplateByIdRequest = (weekRotationTemplateID) => ({
    type: types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST_RADPROFILE,
    payload: { weekRotationTemplateID }
});
export const fetchWeekRotationTemplateByIdSuccess = (templateData) => ({
    type: types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS_RADPROFILE,
    payload: templateData
});
export const fetchWeekRotationTemplateByIdFailure = (error) => ({
    type: types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE_RADPROFILE,
    payload: error
});
export const clearWeekRotationTemplateData = () => ({
    type: types.CLEAR_WEEK_ROTATION_TEMPLATE_DATA_RADPROFILE
});
 
// Save Schedule Week Rotation
export const saveScheduleWeekRotationRequest = (payload, showSuccessMessage = true) => ({
    type: types.SAVE_SCHEDULE_WEEK_ROTATION_REQUEST,
    payload,
    showSuccessMessage
});
export const saveScheduleWeekRotationSuccess = (data) => ({
    type: types.SAVE_SCHEDULE_WEEK_ROTATION_SUCCESS,
    payload: data
});
export const saveScheduleWeekRotationFailure = (error) => ({
    type: types.SAVE_SCHEDULE_WEEK_ROTATION_FAILURE,
    payload: error
});
 
 
//--------------------Edit Provider Profile End -----------------//

// Get Rate Card Details by Rad Id
export const getRateCardDetailsByRadIdRequest = (radiologistID) => ({
    type: types.GET_RATE_CARD_DETAILS_BY_RAD_ID_REQUEST,
    payload: radiologistID
});
export const getRateCardDetailsByRadIdSuccess = (data) => ({
    type: types.GET_RATE_CARD_DETAILS_BY_RAD_ID_SUCCESS,
    payload: data
});
export const getRateCardDetailsByRadIdFailure = () => ({
    type: types.GET_RATE_CARD_DETAILS_BY_RAD_ID_FAILURE
});

// Provider Assignments Dropdown
export const fetchRadAssignmentsDropdownRequest = (radiologistID = 0) => ({
    type: types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_REQUEST,
    payload: { radiologistID }
});
export const fetchRadAssignmentsDropdownSuccess = (data) => ({
    type: types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchRadAssignmentsDropdownFailure = (error) => ({
    type: types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_FAILURE,
    payload: error
});

// Provider Assignments Details
export const fetchRadAssignmentsDetailsRequest = (radiologistID = 0) => ({
    type: types.FETCH_RAD_ASSIGNMENTS_DETAILS_REQUEST,
    payload: { radiologistID }
});
export const fetchRadAssignmentsDetailsSuccess = (data) => ({
    type: types.FETCH_RAD_ASSIGNMENTS_DETAILS_SUCCESS,
    payload: data
});
export const fetchRadAssignmentsDetailsFailure = (error) => ({
    type: types.FETCH_RAD_ASSIGNMENTS_DETAILS_FAILURE,
    payload: error
});

// Save Provider Assignments
export const saveRadAssignmentsRequest = (
    payload,
    showSuccessMessage = true,
    onSuccess = null,
    mode = 'save'
) => ({
    type: types.SAVE_RAD_ASSIGNMENTS_REQUEST,
    payload,
    showSuccessMessage,
    onSuccess,
    mode
});
export const saveRadAssignmentsSuccess = (data) => ({
    type: types.SAVE_RAD_ASSIGNMENTS_SUCCESS,
    payload: data
});
export const saveRadAssignmentsFailure = (error) => ({
    type: types.SAVE_RAD_ASSIGNMENTS_FAILURE,
    payload: error
});

// Delete Provider Assignment
export const deleteRadAssignmentRequest = (payload, onSuccess) => ({
    type: types.DELETE_RAD_ASSIGNMENT_REQUEST,
    payload,
    onSuccess
});
export const deleteRadAssignmentSuccess = (data) => ({
    type: types.DELETE_RAD_ASSIGNMENT_SUCCESS,
    payload: data
});
export const deleteRadAssignmentFailure = (error) => ({
    type: types.DELETE_RAD_ASSIGNMENT_FAILURE,
    payload: error
});

// Fetch Rad Document Types Dropdown
export const fetchRadDocumentTypesRequest = () => ({
    type: types.FETCH_RAD_DOCUMENT_TYPES_REQUEST
});
export const fetchRadDocumentTypesSuccess = (data) => ({
    type: types.FETCH_RAD_DOCUMENT_TYPES_SUCCESS,
    payload: data
});
export const fetchRadDocumentTypesFailure = (error) => ({
    type: types.FETCH_RAD_DOCUMENT_TYPES_FAILURE,
    payload: error
});

// Fetch Rad Documents
export const fetchRadDocumentsRequest = (payload) => ({
    type: types.FETCH_RAD_DOCUMENTS_REQUEST,
    payload
});
export const fetchRadDocumentsSuccess = (data) => ({
    type: types.FETCH_RAD_DOCUMENTS_SUCCESS,
    payload: data
});
export const fetchRadDocumentsFailure = (error) => ({
    type: types.FETCH_RAD_DOCUMENTS_FAILURE,
    payload: error
});

// Upload Rad Document
export const uploadRadDocumentRequest = (payload, onSuccess) => ({
    type: types.UPLOAD_RAD_DOCUMENT_REQUEST,
    payload,
    onSuccess
});
export const uploadRadDocumentSuccess = (data) => ({
    type: types.UPLOAD_RAD_DOCUMENT_SUCCESS,
    payload: data
});
export const uploadRadDocumentFailure = (error) => ({
    type: types.UPLOAD_RAD_DOCUMENT_FAILURE,
    payload: error
});

// Delete Rad Document
export const deleteRadDocumentRequest = (payload, onSuccess) => ({
    type: types.DELETE_RAD_DOCUMENT_REQUEST,
    payload,
    onSuccess
});
export const deleteRadDocumentSuccess = (data) => ({
    type: types.DELETE_RAD_DOCUMENT_SUCCESS,
    payload: data
});
export const deleteRadDocumentFailure = (error) => ({
    type: types.DELETE_RAD_DOCUMENT_FAILURE,
    payload: error
});

// Download Rad Document
export const downloadRadDocumentRequest = (payload, onSuccess) => ({
    type: types.DOWNLOAD_RAD_DOCUMENT_REQUEST,
    payload,
    onSuccess
});
export const downloadRadDocumentSuccess = (data) => ({
    type: types.DOWNLOAD_RAD_DOCUMENT_SUCCESS,
    payload: data
});
export const downloadRadDocumentFailure = (error) => ({
    type: types.DOWNLOAD_RAD_DOCUMENT_FAILURE,
    payload: error
});

// Fetch Rad Note Types
export const fetchRadNoteTypesRequest = () => ({
    type: types.FETCH_RAD_NOTE_TYPES_REQUEST,
});
export const fetchRadNoteTypesSuccess = (data) => ({
    type: types.FETCH_RAD_NOTE_TYPES_SUCCESS,
    payload: data
});
export const fetchRadNoteTypesFailure = (error) => ({
    type: types.FETCH_RAD_NOTE_TYPES_FAILURE,
    payload: error
});

// Fetch Active Home State License Dropdown
export const fetchActiveHomeStateLicenseDropdownRequest = (radiologistID = 0) => ({
    type: types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_REQUEST,
    payload: { radiologistID }
});
export const fetchActiveHomeStateLicenseDropdownSuccess = (data) => ({
    type: types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchActiveHomeStateLicenseDropdownFailure = (error) => ({
    type: types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_FAILURE,
    payload: error
});